import { EnrollmentContextResponseDto } from "theSource/queries/useEnrollmentContextQuery/types";
import { LIFE_EVENT_ENROLLMENT_TYPE } from "theSource/queries/useEnrollmentContextQuery/utils/constants";

export const isLifeEventNotOpen = (
    enrollmentContexts: EnrollmentContextResponseDto
  ) => {
    const contexts = enrollmentContexts.data;
  
    // if open enrollment context is life event and not started, return true
    return contexts.some((context) => {
      return (
        context.enrollment_type_lookup_code === LIFE_EVENT_ENROLLMENT_TYPE &&
        (context.status === 'not_started' || context.status === 'not_open') &&
        context.subscriber_life_event === undefined
      );
    });
  };